import { useEffect } from 'react';

const useBodyScrollLock = (locked) => {
  useEffect(() => {
    if (!locked) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    if (body.style.position === "fixed" && html.style.position === "fixed") {
      return;
    }
    const scrollY = window.scrollY;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    body.style.overflow = "hidden";
    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
      body.style.overflow = "";
      window.scrollTo({ top: scrollY, behavior: "instant" });
    };
  }, [locked]);
};

export { useBodyScrollLock };
